import { CustomFieldChoice } from './custom-field-choice';


export class CustomField {
    id: number;
    title: string;
    field_type = 'text';
    is_required = false;
    order = 0;
    is_active = true;
    choices: CustomFieldChoice[] = [];
}
